var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 110,
    viewBox: "0 0 109 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2882_34959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0017 50.5465C12.0021 50.5463 12.0024 50.5459 12.0024 50.5454C11.9709 43.6085 13.4632 37.3766 16.4628 31.5093C18.4186 27.684 20.9188 24.2478 23.9292 21.1782C26.7138 18.3393 29.8251 15.9275 33.2713 13.9489C38.073 11.192 43.219 9.43046 48.7049 8.67107C51.2089 8.32418 53.7267 8.19993 56.2508 8.31093C61.979 8.56259 67.4416 9.89719 72.6173 12.3784C77.0669 14.5121 81.0247 17.339 84.4741 20.8653C89.4384 25.9401 92.937 31.8833 94.9685 38.6893C95.8856 41.7616 96.4362 44.8962 96.6677 48.0927C97.1168 54.2926 96.2136 60.2863 93.9398 66.0681C92.2571 70.3468 89.9171 74.239 86.9559 77.7571C82.8386 82.6477 77.8825 86.4477 72.0893 89.1478C68.3624 90.8848 64.4596 92.0441 60.3858 92.6306C57.7879 93.0046 55.1786 93.1434 52.5592 93.0292C47.3123 92.8009 42.2685 91.6669 37.4479 89.5666C32.6961 87.4966 28.4647 84.6521 24.7605 81.0261C20.7302 77.081 17.6075 72.5146 15.3994 67.3238C13.8737 63.7363 12.8608 60.0107 12.3675 56.1425C12.1159 54.1699 11.9866 52.1922 12.0011 50.5475C12.0011 50.5471 12.0013 50.5467 12.0017 50.5465ZM54.5227 85.5767C54.5227 85.5771 54.5229 85.5773 54.5233 85.5773C57.314 85.5931 60.0593 85.2436 62.7585 84.5575C67.0941 83.4562 71.0663 81.5717 74.6841 78.9422C79.6169 75.3572 83.4384 70.835 86.0647 65.327C88.3605 60.5115 89.4441 55.4355 89.2347 50.092C89.1319 47.4689 88.7787 44.8823 88.1215 42.3418C86.4501 35.877 83.2669 30.2775 78.4898 25.5969C75.6636 22.8281 72.4558 20.6099 68.8626 18.953C64.0408 16.7297 58.973 15.6991 53.6649 15.8291C50.9862 15.8947 48.3492 16.2479 45.7538 16.9107C40.3864 18.2825 35.6132 20.7947 31.4366 24.4276C27.9058 27.4992 25.0985 31.1378 23.0197 35.3339C21.1774 39.0533 20.0478 42.9776 19.6454 47.1075C19.3988 49.636 19.453 52.1633 19.7494 54.6868C20.1821 58.3658 21.1465 61.8952 22.6961 65.2607C25.3363 70.9946 29.2436 75.6808 34.4249 79.2803C40.4607 83.4732 47.1858 85.5129 54.522 85.5761C54.5224 85.5761 54.5227 85.5764 54.5227 85.5767Z",
    fill: "url(#paint0_linear_2882_34959)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2882_34959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.9046 42.5193C69.9044 42.5192 69.9043 42.5192 69.9043 42.5194C69.8865 43.6148 69.5724 44.456 68.9355 45.139C67.9326 46.2143 66.8995 47.2626 65.8607 48.3033C61.2956 52.8772 56.7274 57.4486 52.1484 62.0087C51.6974 62.4578 51.1954 62.8728 50.6624 63.2197C49.3221 64.0907 47.9787 64.0541 46.7103 63.0702C45.9421 62.4742 45.2401 61.7861 44.5489 61.0986C42.6498 59.209 40.757 57.3118 38.8914 55.3894C37.8847 54.3525 37.3827 53.1062 37.7479 51.6473C38.2676 49.5691 40.5072 48.1368 42.822 49.2411C43.3429 49.4896 43.8362 49.8485 44.2556 50.2471C45.664 51.5861 47.0339 52.9662 48.4183 54.3304C48.7419 54.6495 48.7848 54.6489 49.0976 54.3367C52.8339 50.6129 56.5672 46.8867 60.3092 43.1692C61.4565 42.0295 62.5861 40.8652 63.8034 39.8031C64.9891 38.7681 66.3962 38.6376 67.8141 39.2992C69.2204 39.955 69.8215 41.1658 69.9049 42.5191C69.9049 42.5193 69.9047 42.5194 69.9046 42.5193Z",
    fill: "url(#paint1_linear_2882_34959)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2882_34959",
    x: 0,
    y: 0.271484,
    width: 108.779,
    height: 108.796,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2882_34959"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2882_34959",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2882_34959",
    x: 25.6289,
    y: 30.8926,
    width: 56.2754,
    height: 48.9497,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2882_34959"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2882_34959",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2882_34959",
    x1: 3.51534,
    y1: -18.4347,
    x2: 123.003,
    y2: -9.19533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3295BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33A78C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2882_34959",
    x1: 34.3988,
    y1: 31.0348,
    x2: 79.7066,
    y2: 35.5679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3295BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33A78C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.f12fb6481a8cef56ad5dbfe6432a70c6.svg";
export { ForwardRef as ReactComponent };